import React, { useRef } from "react";
import { arrayOf, bool, string } from "prop-types";
import { Navigate, Outlet } from "react-router-dom";
import { useAccessControl } from "@hooks";
import { ADMIN_ROLE } from "@constants";

const PrivateRoute = ({
  targetRoles,
  exceptRoles,
  authRequired,
  authRejected,
}) => {
  // state

  // variables

  // logics before hooks

  // hooks
  const prevAuthRef = useRef(null);
  const { isAuth, role, permission } = useAccessControl(
    targetRoles,
    exceptRoles
  );

  // logics
  const isAdmin = role === ADMIN_ROLE;
  const logOutDetected = prevAuthRef.current;
  prevAuthRef.current = isAuth;

  // UI partials

  // effects

  // render
  if (!isAuth) {
    if (authRequired || logOutDetected) {
      return <Navigate to="/sign-in" replace />;
    }
  } else {
    if (authRejected) {
      return <Navigate to={isAdmin ? "/admin" : "/"} replace />;
    }
  }
  if (!permission) {
    return <Navigate to={isAdmin ? "/admin" : "/access-denied"} replace />;
  }
  return <Outlet />;
};

/* required: display name */
PrivateRoute.displayName = "PrivateRoute";

/* required: props types */
PrivateRoute.propTypes = {
  targetRoles: arrayOf(string),
  exceptRoles: arrayOf(string),
  authRequired: bool,
  authRejected: bool,
};

/* required: default props */
PrivateRoute.defaultProps = {
  targetRoles: [],
  exceptRoles: [],
  authRequired: true,
  authRejected: false,
};

export { PrivateRoute };
